// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ZC47HjMoP2CusG {
  padding-top: var(--ds-space-600, 48px);
  background-color: var(--ds-surface, #ffffff);
}
.Au1WmI1YwPgWNR {
  position: sticky;
  z-index: 1;
  top: var(--ds-space-0, 0);
}
.BNm50Vev7DSoVy {
  margin-bottom: var(--ds-space-200, 16px);
  font-size: 20px;
  line-height: 24px;
}
`, ""]);
// Exports
export var header = `ZC47HjMoP2CusG`;
export var sticky = `Au1WmI1YwPgWNR`;
export var title = `BNm50Vev7DSoVy`;
export default ___CSS_LOADER_EXPORT___;
